import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/check-circle': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM256 56c-110.5 0-200 89.5-200 200 0 110.5 89.5 200 200 200 110.5 0 200-89.5 200-200 0-110.5-89.5-200-200-200zM396.2 186.3c4.7 4.7 4.6 12.3-0.1 17l-172.6 171.2c-4.7 4.7-12.3 4.6-17-0.1l-90.8-91.5c-4.7-4.7-4.6-12.3 0.1-17l22.7-22.5c4.7-4.7 12.3-4.6 17 0.1l59.8 60.3 141.4-140.2c4.7-4.7 12.3-4.6 17 0.1z'
      }
    ]
  }
})
